import Vue from 'vue';
import sesionService from '@/services/SesionService';

export default {
	name: 'Sidebar',
	components: {},
	props: [],
	data() {
		return {
			user: {},
			isCommonUser: false
		};
	},
	created() {
		this.user = sesionService.getUser().Data;
		this.isCommonUser = this.user.type == 3;

		const mixpanel_distinct_id = this.$mixpanel.get_distinct_id();

		if (mixpanel_distinct_id !== this.user.perfil.email) {
			console.log(
				`MIXPANEL: This is the distinct_id: ${mixpanel_distinct_id} we got from mixpanel, and it's diferent from the created distinct_id: ${this.user.perfil.email}.`
			);
			this.$mixpanel.identify(this.user.perfil.email);
		}
	},
	methods: {
		logout: function () {
			sessionStorage.clear();
			sesionService.logout();
			Vue.prototype.$mixpanel.reset();
		}
	}
};
